import { Grid, Skeleton, Typography } from '@mui/material'
import React from 'react'
import Button from '../atoms/Button'
import BodyHeader from '../molecules/BodyHeader'
import IdentityBox from '../molecules/IdentityBox'
import Zone from '../organisms/Zone'
import useReferentTeam from '../../hooks/useReferenceTeam'
import { APP_BASE_URL, RECRUITMENT_URL } from '../../constants'
import usePole from '../../hooks/usePole'
import useDirector from '../../hooks/useDirector'

const ReferenceTeam = () => {
	const { isLoading, title, content } = useReferentTeam()
	const { poles } = usePole()
	const { directors } = useDirector()

	return (
		<>
			{(isLoading && <Skeleton />) || <BodyHeader title={title}>{content}</BodyHeader>}
			<Zone color="white">
				<Typography variant="h3" color="secondary" sx={{ fontSize: 16, fontWeight: 900 }}>
					l’équipe permanente
				</Typography>
				<Typography variant="h4" color="text.primary" sx={{ fontSize: 32, fontWeight: 700 }}>
					Penser le travail comme une aventure humaine et collective
				</Typography>
				<Typography
					component="p"
					color="text.primary"
					sx={{ fontSize: 18, fontWeight: 400, m: (theme) => theme.spacing(2, 0) }}
				>
					Notre gouvernance est fondée sur les principes de co-construction collective, de
					transparence des informations, de partage de connaissances, des savoirs et savoir-faire de
					tous : conseil d’administration, salariés, services civiques, bénévoles, stagiaires,
					étudiants, partenaires, artistes... L’organisation du travail y est horizontale et
					répartie par pôles d’activités et de compétences.
				</Typography>
			</Zone>

			{poles &&
				poles.map((polesByCategory, index) => (
					<Zone color="ivory" key={index} m={2}>
						{Object.keys(polesByCategory)[0] && (
							<Typography
								component="h3"
								sx={{
									fontSize: 22,
									fontWeight: 800,
									bgcolor: 'text.primary',
									color: 'white',
									display: 'table',
									m: (theme) => theme.spacing(2, 'auto', 4),
									p: 2,
								}}
							>
								{Object.keys(polesByCategory)[0]}
							</Typography>
						)}

						<Grid container sx={{ justifyContent: 'center' }}>
							{polesByCategory &&
								Object.values(polesByCategory)[0].map(
									({ title, description, image, email }, uIndex) => (
										<Grid item xs={12} md={3} key={`${index}${uIndex}`}>
											<IdentityBox
												fullName={title}
												body={description}
												image={image}
												email={email}
											/>
										</Grid>
									),
								)}
						</Grid>
					</Zone>
				))}

			{directors &&
				directors.map(({ title, body }, index) => (
					<Zone color="ivory" key={index} m={2}>
						<Typography
							component="h3"
							sx={{
								fontSize: 22,
								fontWeight: 800,
								bgcolor: 'text.primary',
								color: 'white',
								display: 'table',
								m: (theme) => theme.spacing(2, 'auto', 4),
								p: 2,
							}}
						>
							{title}
						</Typography>

						<Typography
							component="div"
							sx={{
								display: 'flex',
								justifyContent: 'space-between',
								'& h2': {
									color: 'text.primary',
									fontWeight: 800,
									fontSize: 18,
									mb: 1,
									textTransform: 'uppercase',
								},
								'& ul': { p: 0 },
								'& li': { color: 'text.primary', fontWeight: 400, fontSize: 16, listStyle: 'none' },
								'& .wp-block-group, & figure': {
									textAlign: 'left',
								},
								'& figure': { m: 0 },
								'& p': {
									display: 'none',
								},
							}}
							dangerouslySetInnerHTML={{ __html: body }}
						/>
					</Zone>
				))}

			<Zone color="white">
				<Typography variant="h4" color="text.primary" sx={{ fontSize: 32, fontWeight: 700 }}>
					Vous souhaitez nous rejoindre ?
				</Typography>
				<Typography
					component="p"
					color="text.primary"
					sx={{ fontSize: 18, fontWeight: 400, m: (theme) => theme.spacing(2, 10) }}
				>
					L’univers de La Collecterie vous plaît et vous avez des compétences qui pourraient nous
					être utiles ? Jetez un œil à nos fiches de poste !
				</Typography>
				<Button
					label="Voir les fiches de poste"
					color="white"
					bgColor="green"
					href={`${APP_BASE_URL}${RECRUITMENT_URL}`}
				/>
			</Zone>
		</>
	)
}

export default ReferenceTeam
